import React from "react"
import { useLocation } from "react-router-dom"
import GamesProvider from "contexts/GamesContext"
import SpeechSettingsProvider from "contexts/SpeechSettingsContext"
import TranslatorProvider from "contexts/TranslatorContext"
import ActiveContentProvider from "contexts/ActiveContentContext"
import { routes, prefixRoutes } from "common/navigationRoutes"
import { useGameTracker } from "../pages/games/hooks/useGameTracker"
import PlacementProvider from "contexts/PlacementContext"
import ModuleProvider from "contexts/ModuleContext"

const GamesTracker = () => {
  useGameTracker()
  return null
}

export const GamesRouteProviders = ({ children }) => {
  const location = useLocation()
  const prefix = process.env.PUBLIC_URL || ""
  const basePath = location.pathname
    ?.toLowerCase()
    .startsWith(prefix.toLowerCase())
    ? location.pathname?.substring(prefix.length)
    : location.pathname

  const cleanPath = basePath?.toLowerCase() || ""
  const professorGamesListRoute = `${prefixRoutes.PROFESSOR}${routes.NEW_GAMES}`
  const isProfessorGamesList =
    cleanPath === professorGamesListRoute ||
    cleanPath === `${professorGamesListRoute}/`
  const isGamesRoute =
    cleanPath.includes(routes.NEW_GAMES) && !isProfessorGamesList
  const isProfessorRoute = cleanPath.startsWith(prefixRoutes.PROFESSOR)

  if (isGamesRoute) {
    const content = (
      <TranslatorProvider>
        <GamesProvider>
          {!isProfessorRoute && <GamesTracker />}
          <SpeechSettingsProvider>{children}</SpeechSettingsProvider>
        </GamesProvider>
      </TranslatorProvider>
    )
    if (isProfessorRoute) {
      return (
        <ActiveContentProvider>
          <PlacementProvider>
            <ModuleProvider>{content}</ModuleProvider>
          </PlacementProvider>
        </ActiveContentProvider>
      )
    }
    return content
  }
  return <>{children}</>
}
